__turbopack_context__.v({
  "ctaBtn": "TabSection-module__UF6Daq__ctaBtn",
  "eyebrow": "TabSection-module__UF6Daq__eyebrow",
  "featureItem": "TabSection-module__UF6Daq__featureItem",
  "featureText": "TabSection-module__UF6Daq__featureText",
  "featuresCol": "TabSection-module__UF6Daq__featuresCol",
  "floatL": "TabSection-module__UF6Daq__floatL",
  "floatR": "TabSection-module__UF6Daq__floatR",
  "left": "TabSection-module__UF6Daq__left",
  "notch": "TabSection-module__UF6Daq__notch",
  "phone": "TabSection-module__UF6Daq__phone",
  "right": "TabSection-module__UF6Daq__right",
  "screen": "TabSection-module__UF6Daq__screen",
  "sectionHead": "TabSection-module__UF6Daq__sectionHead",
  "sectionTitle": "TabSection-module__UF6Daq__sectionTitle",
  "softwareFeatures": "TabSection-module__UF6Daq__softwareFeatures",
  "subtitle": "TabSection-module__UF6Daq__subtitle",
  "tray": "TabSection-module__UF6Daq__tray",
});
